import { type } from "jquery";

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        TextareaControl,
        SelectControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/content-slide', {
        // built-in attributes
        title: 'Content Slide',
        description: 'Content Slide',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            },
            offerText: {
                type: 'string',
                default: ''
            },
            icon: {
                type: 'string',
                default: ''
            },
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            cta: {
                type: 'string',
                default: 'Vidi više'
            },

        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                image,
                alt,
                offerText,
                title,
                description,
                cta,
                icon
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onSelectImage (image) {
                setAttributes({image: image.sizes.full.url});
            }

            function onAltChange(alt) {
                setAttributes({alt: alt});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onOfferTextChange(offerText) {
                setAttributes({offerText: offerText});
            }

            function onIconChange(badge) {
                setAttributes({icon: badge});
            }

            function onCtaChange(cta) {
                setAttributes({cta: cta});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                        <br />
                        <p><strong>Alt image:</strong></p>
                        <TextControl value={ alt } onChange={ onAltChange }></TextControl>
                        <br />

                        <p><strong>Enter url: (ex: /putovanja)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                        <br />

                        <p><strong>Offer text: (vec od 100 €)</strong></p>
                        <TextControl value={ offerText } onChange={ onOfferTextChange }></TextControl>
                        <br />

                        <p><strong>Icon</strong></p>
                        <SelectControl label="select icon" 
                            value={ icon } 
                            options= { [
                                { label: '', value:''},
                                { label: 'Bus', value: 'las la-bus'},
                                { label: 'Plane', value: 'las la-plane'},
                            ] }
                            onChange={ ( onIconChange ) }
                        />
                        <br />

                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <br />

                        <p><strong>Description</strong></p>
                        <TextControl value={ description } onChange={ onDescriptionChange }></TextControl>
                        <br />

                        <p><strong>Cta</strong></p>
                        <TextControl value={ cta } onChange={ onCtaChange }></TextControl>

                    </PanelBody>
                </InspectorControls>
                ,
                <a class="card card-destination">
                    <div class="card-img-top">
                        <img class="cover-image" src={ image } alt={ alt } />
                        <div className={ "offer-cta " + (offerText ? '' : 'd-none')}>
                            <RichText 
                                key="editable" 
                                tagName="div"
                                className="title" 
                                value={ offerText }
                                onChange={ onOfferTextChange } />
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="title-container">
                            <RichText 
                                key="editable" 
                                tagName="h4"
                                className="title"
                                placeholder="TITLE" 
                                value={ title }
                                onChange={ onTitleChange } />
                        </div>
                        <div class="description">
                            <RichText 
                                key="editable" 
                                tagName="div"
                                className="description"
                                value={ description }
                                onChange={ onDescriptionChange } />
                        </div>
                        <div class="cta-btn">
                            <RichText 
                                key="editable" 
                                tagName="div"
                                className="text"
                                value={ cta }
                                onChange={ onCtaChange } />
                            <i class="las la-angle-double-right"></i>
                        </div>
                    </div>
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                image,
                alt,
                offerText,
                title,
                description,
                cta,
                icon
            } = attributes;

            return (
                <div className="keen-slider__slide">
                    <a href={ link } className={ "card card-offer "}>
                        <div className="card-img-top">
                            <img className="lozad cover-image" data-src={ image } alt={ alt } />
                            <div className={ "offer-cta " + (offerText ? '' : 'd-none')}>
                                { offerText }
                            </div>
                            
                        </div>
                        <div className="card-body">
                            <div className="title-container">
                                <h4 className="title">
                                    <i className={ icon ? icon : 'd-none' }></i>
                                    { title }
                                </h4>
                            </div>
                            <div className="description">
                                { description }
                            </div>
                        </div>
                    </a>
                </div>
            );
        },
    });
}